const isSiteLinkExtension = (ext) => ext._type === 'Ads/SiteLinkExtension';

export const hasSiteLinkExtension = (extensions = []) => extensions.some(isSiteLinkExtension);

export const getSiteLinkExtension = (extensions = []) => extensions.find(isSiteLinkExtension);

export const getSiteLinks = ({ siteLinks = [] }) =>
    siteLinks.map(({ text, link }) => ({ text, link }));
